export const attendanceActionMapper = {
  LEAVE: 'On leave today',
  WFO_WIFI: 'WFO today',
  WFH_WIFI: 'Remote work today; In office',
  Pending_WIFI: 'Attendance pending; In office',
  WFO_NOWIFI: 'WFO today; Hasn’t arrived yet',
  WFH: 'Remote work today',
  PENDING_NOWIFI: 'Attendance pending',
};
